module.exports = __webpack_public_path__ + "static/media/novihome2.1f11beb6.png";